import React from 'react';
import BulletinProvider from '../../context/bulletin';
import BulletinView, { BulletinViewProps } from './BulletinView';

function BulletinViewPage(props: BulletinViewProps) {
  return (
    <BulletinProvider>
      <BulletinView {...props} />
    </BulletinProvider>
  );
}

export default BulletinViewPage;
